<template>
  <ModalFullscreen modal-id="modal-id-menu">
    <div class="container pt-2">
      <div class="mb-4 flex items-end">
        <button
          type="button"
          class="btn p-2 mi-no-mx ml-auto border-0"
          data-dismiss="modal"
          aria-label="Close"
          @click="closeModal"
        >
          <i class="mi-times icon-28 mi-no-mx mi-lh-1" />
        </button>
      </div>
      <MegaMenu id="modalmenu" />
      <MenuList />
      <CustomersCare />
      <SocialLinks />
      <Languages />
    </div>
  </ModalFullscreen>
</template>

<script setup>
import { useModalStore } from '@/stores/ModalStore'

import ModalFullscreen from '@/components/general/BaseModalFullscreen.vue'
import MegaMenu from '@/components/menus/megamenu/TheMegamenu.vue'
import CustomersCare from '@/components/menus/mobile_menu/TheMobileMenuCustomersCare.vue'
import Languages from '@/components/menus/mobile_menu/TheMobileMenuLanguages.vue'
import MenuList from '@/components/menus/mobile_menu/TheMobileMenuList.vue'
import SocialLinks from '@/components/menus/mobile_menu/TheMobileMenuSocial.vue'

const { closeModal } = useModalStore()
</script>
